
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[state]/[restaurant]",
      function () {
        return require("private-next-pages/restaurants/[state]/[restaurant].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/[state]/[restaurant]"])
      });
    }
  